import Cookies from "js-cookie";

export const getHeaders = (isForm = false) => {
  const token = Cookies.get("token");
  // console.log("Token", token);
  if (isForm) {
    return {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
        // "Content-Type": "application/json",
      },
    };
  }

  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};
